import React from "react";
import classNames from "classnames";
import styles from "./Grid.module.scss";

const COL_SPAN_MAX = 12;

const clampSpan = (n: number) =>
    Math.min(COL_SPAN_MAX, Math.max(1, Math.round(n)));

interface GridColProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    className?: string;
    /**
     * Column span on mobile (below sm breakpoint). Defaults to 12 when sm is set.
     */
    xs?: number;
    /**
     * Column span from the sm breakpoint and up.
     * Use sm={6} for full width on mobile (12), half width from sm up (6).
     * Omit for always full width (12).
     */
    sm?: number;
}

export const GridCol: React.FC<GridColProps> = ({
    children,
    className,
    xs,
    sm,
    style,
    ...rest
}) => {
    const useResponsive = sm !== undefined;
    const spanClass = useResponsive ? styles.colResponsive : styles.colSpan12;

    const responsiveStyle: React.CSSProperties | undefined = useResponsive
        ? ({
              ...style,
              "--col-span-xs": xs !== undefined ? clampSpan(xs) : 12,
              "--col-span-sm": clampSpan(sm),
          } as React.CSSProperties)
        : undefined;

    return (
        <div
            className={classNames(styles.col, spanClass, className)}
            style={responsiveStyle ?? style}
            {...rest}
        >
            {children}
        </div>
    );
};

GridCol.displayName = "GridCol";
